
import { defineComponent } from "vue";
import Spinner from "./Spinner.vue";

export default defineComponent({
    name: "SpinnerContainer",
    components: { Spinner },
});
